require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-toorak-garden-residence-featured-in-habitusliving-2.json") })
        }
      }, "path---journal-toorak-garden-residence-featured-in-habitusliving-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-toorak-garden-residence-featured-in-habitusliving-2!./.cache/json/journal-toorak-garden-residence-featured-in-habitusliving-2.json
// module id = 546
// module chunks = 231608221292675